import axios from './index'

class my {

    //领取新人礼包优惠券
    static receiveGift(options) {
        return axios.get('/nice-api-customer/v1/coupon/newCustomerGiftBag', {params:options})
    }

    //查询是否为新用户
    static getIsNew(options) {
        return axios.get('/nice-api-customer/v1/coupon/customer/verify', {params:options})
    }

    //查询客户地址
    static customerAddress(options) {
        return axios.get('/nice-api-customer/v1/address/customer', {params:options})
    }
    
    //根据ID查询地址
    static customerAddressById(options) {
        return axios.get(`/nice-api-customer/v1/address/${options}`)
    }
    
    //获取省份
    static getProvince(options = {}) {
        return axios.get(`/nice-api-order/v1/chinaArea/province`, options)
    }
    
    //获取市区
    static getCity(options) {
        return axios.get(`/nice-api-order/v1/chinaArea/${options.code}/children`, options)
    }


    //新建地址
    static addAdress(options) {
        return axios.post(`/nice-api-customer/v1/address`,options)
    }
        
    //删除客户地址
    static delAdress(options) {
        return axios.delete(`/nice-api-customer/v1/address/${options}`)
    }
    
    //修改客户地址
    static editAdress(options) {
        return axios.patch(`/nice-api-customer/v1/address`,options)
    }
    

    //查询用户信息
    static customerInfo(options) {
        return axios.get(`/nice-api-customer/v1/other/customerInfo`)
    }
    

        
    //查询优惠券列表
    static getCoupon(options) {
        return axios.get(`/nice-api-customer/v1/coupon/customer`,{params:options})
    }

    //查询充值列表
    static getRecharge(options) {
        return axios.get(`/nice-api-customer/v1/recharge/enable`,{params:options})
    }

    //查询充值列表
    static balanceRecord(options) {
        return axios.get(`/nice-api-customer/v1/other/balanceRecord`)
    }
    
    //查询已购服务
    static customerCuringService(options) {
        return axios.get(`/nice-api-order/v1/customerCuringService/info`,{params:options})
    }

    static customerCuringServiceRefound(options) {
        return axios.get(`/nice-api-order/v1/customerCuringService/refundInfo`,{params:options})
    }
    
    
    //取消已购服务
    static concelCuringService(options) {
        return axios.patch(`/nice-api-order/v1/customerCuringService/${options.id}/refund`,options);
    }
        

    //上传图片
    static uploadImg(options) {
        return axios.post(`/nice-api-order/v1/upload/file`,options);
    }

    //添加反馈
    static feedBack(options) {
        return axios.post(`/nice-api-customer/v1/other/feedback`,options);
    }

    
    //获得用户是否领取个赠品
    static getshareGift(options) {
        return axios.get(`/nice-api-customer/v1/activity/sharePresent`,{params:options});
    }

    //获得用户是否领取个赠品
    static shareGift(options) {
        return axios.get(`/nice-api-customer/v1/other/shareGift/drew`,{params:options});
    }
    
    //客户领取【分享有礼】礼品
    static postShareGift(options) {
        return axios.post(`/nice-api-customer/v1/other/shareGift/draw`,options);
    }
    
    //分享获取微信标签
    static jsApiSignature(options) {
        return axios.get(`/nice-api-customer/v1/weChat/jsApiSignature`,{params:options});
    }

    //结算单详情
    static createOrder(options) {
        return axios.post(`/nice-api-order/v1/settlement/payment`,options);
    }
    
    //结算单详情
    static createOrderOther(options) {
        return axios.post(`/nice-api-order/v1/scheme/payment`,options);
    }

    //创建在线订单
    static createOnlineOther(options) {
        return axios.post(`/nice-api-order/v1/virtualGoods/payment`,options);
    }
    
    
    //充值
    static recharge(options) {
        return axios.post(`/nice-api-order/v1/settlement/recharge`,options);
    }

    //在线订单结算
    static onlineDetail(options) {
        return axios.get(`/nice-api-order/v1/virtualGoods/settlement`,{params:options});
    }

    //物品结算单详情
    static schemesettlement(options) {
        return axios.get(`/nice-api-order/v1/scheme/settlement`,{params:options});
    }
    
    //结算单详情
    static settlement(options) {
        return axios.get(`/nice-api-order/v1/settlement`,{params:options});
    }

    //给客机绑定uinid
    static bindServicePhone(options) {
        return axios.post(`/nice-api-marketing-campaign/v1/servicePhone`,options);
    }

    //获取登录人的影响工具列表
    static marketingCampaign(options) {
        return axios.get(`/nice-api-marketing-campaign/v1/marketingCampaign/${options}/bindMarketingCampaign`);
    }

    
    //获取分享code
    static createShareCode(options) {
        return axios.post(`/nice-api-marketing-campaign/v1/marketingCampaignRecord/createShareCode`,options);
    }
    
        
    //根据code获取礼品
    static getCodeShare(options) {
        return axios.get(`/nice-api-marketing-campaign/v1/marketingCampaignRecord/${options}/searchCode`);
    }

    

    //领取礼品
    static getShareGoods(options) {
        return axios.post(`/nice-api-marketing-campaign/v1/marketingCampaignRecord/receiveAward`,options);
    }


    //客服分享后回调
    static shareGoodsBack(options) {
        return axios.get(`/nice-api-marketing-campaign/v1/marketingCampaignRecord/${options.code}/shareCode`,{params:options});
    }
    
    //客服时间休息
    static getCustomerServiceTime() {
        return axios.get(`/nice-api-customer/v1/other/getCustomerServiceTime`);
    }

    
}

export default my;
